$(".slider").slick({
	dots: false,
	infinite: false,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
});

$(window).on("scroll", function () {
	if ($(this).scrollTop() > 0) {
		$("body").addClass("scrolled");
	} else {
		$("body").removeClass("scrolled");
	}
});

const $btn = $("#btn");
const $target = $("body");

/*
function openMenu(button, target, className) {
	button.prop("checked")
		? target.addClass(className)
		: target.removeClass(className);
}

$btn.on("click", (e) => {
	openMenu($(e.target), $target, "menuopen");
});

const menuToggle = document.querySelector(".menu-toggle");
const nav = document.querySelector("nav");

menuToggle.addEventListener("click", () => {
	nav.classList.toggle("active");
});
*/
// Mobile Nav Toggle (if you have hamburger)
const nav = document.querySelector("nav");
const menuToggle = document.querySelector(".menu-toggle");

if (menuToggle) {
	menuToggle.addEventListener("click", () => {
		nav.classList.toggle("active");
	});
}

$(document).ready(function () {
	if (!localStorage.getItem("cookieMessageClosed")) {
		$(".cookie-message").show();
	} else {
		$(".cookie-message").hide();
	}

	$(".btn-close").on("click", function () {
		$(".cookie-message").remove();
		localStorage.setItem("cookieMessageClosed", "true");
	});
});
